import { useState } from "react";
import useMerchantPortalAxios, {
  useMerchantPortalFormData,
} from "../utils/axios";
import { useDispatch } from "react-redux";
import { setResponseData } from "../features/transactionDetailsSlice";
import { setResponseAbroadData } from "../features/transferAbroadDetailsSlice";
import axios from "axios";
import { config } from "../utils/Constants";

const TransactionDetailsAPI = () => {
  const MerchantPortalAxios = useMerchantPortalAxios();
  const MerchantPortalAxios1 = useMerchantPortalFormData();
  const URL = config.url;

  const dispatch = useDispatch();

  async function GetTransactionDetails(TransactionID, AdditionalInfo = "") {
    dispatch(setResponseData({ field: "loading", value: true }));
    await MerchantPortalAxios.post(
      `/v1/TransactionDetails/GetTransactionDetails`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        TransactionID: TransactionID,
        AdditionalInfo: AdditionalInfo
      }
    ).then((res) => {
      
      dispatch(
        setResponseData({
          field: "transactionDetails",
          value: res.data.Payload.TransactionDetails,
        })
      );
      dispatch(
        setResponseAbroadData({
          field: "transferDetails",
          value: res.data.Payload.TransactionDetails,
        })
      );
      dispatch(setResponseData({ field: "loading", value: false }));
    });
  }

  async function GetTransactionDetailsMobile(TransactionID) {
    dispatch(setResponseData({ field: "loading", value: true }));
    await axios
      .post(
        `${URL}/v1/TransactionDetails/GetTransactionDetails`,
        {
          SessionID: sessionStorage.getItem("SessionMobile"),
          TransactionID: TransactionID,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("TokenMobile"),
          },
        }
      )
      .then((res) => {
        dispatch(
          setResponseData({
            field: "transactionDetails",
            value: res.data.Payload.TransactionDetails,
          })
        );
        dispatch(
          setResponseAbroadData({
            field: "transferDetails",
            value: res.data.Payload.TransactionDetails,
          })
        );
        dispatch(setResponseData({ field: "loading", value: false }));
      });
  }

async function UploadTransactionDetailsFile(payload) {
  const requestPayload = {
    SessionID: sessionStorage.getItem("SessionID"),
    TransactionID: payload.TransactionID,
    ReasonFile: payload.ReasonFile,
    IsInvoice: Boolean(payload.IsInvoice),
  };

  if (payload.ReasonFile) {
    const fileData = payload.ReasonFile.split(",")[1];
    const mimeType = payload.ReasonFile.split(":")[1].split(";")[0];
    const byteCharacters = atob(fileData);
    const byteArrays = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
    }

    requestPayload.ReasonFile = new File(
      [byteArrays],
      payload.ReasonFileName,
      { type: mimeType }
    );
  }

  await MerchantPortalAxios1.post(
    `/v1/TransactionDetails/UploadTransactionDetailsFile`,
    requestPayload
  );
}

  return {
    GetTransactionDetails,
    GetTransactionDetailsMobile,
    UploadTransactionDetailsFile,
  };
};

export default TransactionDetailsAPI;
